export const radius = {
  4: '4px',
  8: '8px',
  16: '16px',
  24: '24px',
  48: '48px',
  100: '100px',
  full: '100%',
} as const;
